// extracted by mini-css-extract-plugin
export default {"dynamicInput":"DynamicInput_dynamicInput__fuW0V"};